import { REQUEST_TABLE_FILTERS } from 'utils/constants';

export const REQUEST_STATUSES = {
  SUBMITTED: 'submitted',
  DRAFT: 'draft',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING_CANCELLATION: 'pending_cancellation',
  CANCELED: 'canceled',
  WAITLISTED: 'waitlisted',
  PENDING_PAGE_APPROVAL: 'pending_page_approval',
  COMPLETED: 'completed',
} as const;

export const DB_REQUEST_STATUSES = {
  SUBMITTED: 'submitted',
  DRAFT: 'draft',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING_CANCELLATION: 'pending_cancellation',
  CANCELED: 'canceled',
  WAITLISTED: 'waitlisted',
  PENDING_PAGE_APPROVAL: 'pending_page_approval',
  COMPLETED: 'completed',
} as const;

// COMPLETED is excluded: it rides the advanced-requests-completed-status flag
// end to end, and a backend build without the CGP-178 enum rejects the whole
// list request when `completed` appears in filter[status]. Use this as the
// implicit "all statuses" default; flag-aware call sites add COMPLETED
// explicitly (see useFilteredStatuses).
export const DEFAULT_REQUEST_STATUS_FILTER = Object.values(
  DB_REQUEST_STATUSES
).filter((status) => status !== DB_REQUEST_STATUSES.COMPLETED);

export const ACTIVE_REQUEST_STATUSES_MAPPING = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  PENDING_CANCELLATION: 'pending_cancellation',
  WAITLISTED: 'waitlisted',
  PENDING_PAGE_APPROVAL: 'pending_page_approval',
} as const;

export const ACTIVE_REQUEST_STATUSES = [
  REQUEST_STATUSES.DRAFT,
  REQUEST_STATUSES.SUBMITTED,
  REQUEST_STATUSES.PENDING_CANCELLATION,
  REQUEST_STATUSES.WAITLISTED,
  REQUEST_STATUSES.PENDING_PAGE_APPROVAL,
] as const;

// The set of statuses a request can be actively moved between. This drives
// runtime behavior (the TopBar status-menu gate, the project-request fetch in
// RequestsDropdown, and selectRequestsInEditableStatus), so COMPLETED is
// intentionally NOT here — a Completed request is terminal for those flows.
// Eligibility for the Completed confirmation modal is expressed separately via
// RequestStatusModalTarget (see utils/types/request.d.ts).
export const EDITABLE_REQUEST_STATUSES = [
  REQUEST_STATUSES.APPROVED,
  REQUEST_STATUSES.WAITLISTED,
  REQUEST_STATUSES.SUBMITTED,
  REQUEST_STATUSES.REJECTED,
] as const;

export const REQUEST_PRIORITY = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
} as const;

export const QUICK_FILTERS = [
  REQUEST_TABLE_FILTERS.MY_REQUESTS,
  REQUEST_TABLE_FILTERS.OPEN_REQUESTS,
];

export const REQUEST_TABLE_COLUMNS = {
  REQUEST_NO: 'requestIdentifier',
  REQUEST_TITLE: 'title',
  STATUS: 'status',
  REQUESTER_NAME: 'requester',
  OWNER_NAME: 'owner',
  LINKED_PROJECTS: 'projectRequests',
  FORM: 'form',
  CREATION_DATE: 'createdAt',
  SUBMISSION_DATE: 'submittedAt',
  DECISION_DATE: 'decisionDate',
  UPDATE_DATE: 'updatedAt',
  PRIORITY: 'ldPriority',
  BUSINESS_UNIT: 'requestBusinessTeams',
};
